<div class="pricing-results-attributes">
  <clr-tree>
    <clr-tree-node
      [(clrExpanded)]="pricingResultsExpanded"
      *ngFor="let attribute of resultSpecifications | resultsHeader: true"
    >
      {{ attribute.longName }}
      <clr-tree-node
        style="display: block"
        *ngFor="let attribute of resultSpecifications | resultsHeader: false"
      >
        <div *ngIf="tooltip(attribute.shortName) as tt; else defaultTmpl">
          <span
            style="float: right; margin-right: 0.5rem"
            class="cp-tooltip"
            [attr.data-tooltip]="tt"
          >
            {{ attribute.longName }}
            <cds-icon shape="info-standard" size="14"></cds-icon>
          </span>
        </div>
        <ng-template #defaultTmpl>
          <div style="float: right; margin-right: 0.5rem">
            {{ attribute.longName }}
          </div>
        </ng-template>
      </clr-tree-node>
    </clr-tree-node>
  </clr-tree>
</div>
